var _module_exports = "<div>\n  <h2>{{ $ctrl._identify }}</h2>\n  <div ng-bind-html=\"::$ctrl.comment.markedHTML\"></div>\n</div>\n";;
var path = '/workspace/src/app/components/workroom/activity-stream/comment/comment.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;